<script lang="ts" setup generic="T">
import { RadioGroup } from '@headlessui/vue'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

export interface Option<T> {
  value: T
  icon?: string | IconDefinition
  iconSize?: string
  label: string
}

defineProps<{
  containerClass?: string

  // Lay the options out in a row instead of the default vertical stack.
  horizontal?: boolean

  options?: Option<T>[]

  // Provided automatically by GInput.
  hasErrors?: boolean
}>()

const selectedValue = (defineModel<T>())
</script>

<template>
  <RadioGroup
    v-model="selectedValue as any"
    class="flex g-input-field"
    :class="[
      horizontal ? 'flex-row flex-wrap items-center' : 'flex-col',
      containerClass || (horizontal ? 'gap-4' : 'gap-1'),
    ]"
  >
    <slot>
      <GRadioOption
        v-for="option in options"
        :key="String(option.value)"
        :value="option.value"
        :label="option.label"
        :hasErrors="hasErrors"
      />
    </slot>
  </RadioGroup>
</template>
